import { useMemo } from 'react';
import { useMechanicValidatorSettlement } from '../../../store/selectors/useMechanicValidatorSettlement.ts';
import { useMechanicValidatorRoad } from '../../../store/selectors/useMechanicValidatorRoad.ts';
import { useMechanicValidatorCity } from '../../../store/selectors/useMechanicValidatorCity.ts';
import { useMechanicValidatorShip } from '../../../store/selectors/useMechanicValidatorShip.ts';
import { useMechanicValidatorCityWall } from '../../../store/selectors/useMechanicValidatorCityWall.ts';
export const usePlayerInfoSectionContentPiecesProps = (playerColor)=>{
    const roadValidator = useMechanicValidatorRoad();
    const roadCount = roadValidator === null || roadValidator === void 0 ? void 0 : roadValidator.getRoadPlayerState(playerColor).bankRoadAmount;
    const settlementValidator = useMechanicValidatorSettlement();
    const settlementCount = settlementValidator === null || settlementValidator === void 0 ? void 0 : settlementValidator.getSettlementPlayerState(playerColor).bankSettlementAmount;
    const cityValidator = useMechanicValidatorCity();
    const cityCount = cityValidator === null || cityValidator === void 0 ? void 0 : cityValidator.getCityPlayerState(playerColor).bankCityAmount;
    const shipValidator = useMechanicValidatorShip();
    const shipCount = shipValidator === null || shipValidator === void 0 ? void 0 : shipValidator.getShipPlayerState(playerColor).bankShipAmount;
    const cityWallValidator = useMechanicValidatorCityWall();
    const cityWallCount = cityWallValidator === null || cityWallValidator === void 0 ? void 0 : cityWallValidator.getCityWallPlayerState(playerColor).bankCityWallAmount;
    return useMemo(()=>({
            playerColor: playerColor,
            roadCount: roadCount,
            settlementCount: settlementCount,
            cityCount: cityCount,
            shipCount: shipCount,
            cityWallCount: cityWallCount
        }), [
        playerColor,
        roadCount,
        settlementCount,
        cityCount,
        shipCount,
        cityWallCount
    ]);
};
